module.exports = __webpack_public_path__ + "static/bezirksamt-spandau-a751adeb3138c744fdb53f6c2c4f8b78.svg";